// extracted by mini-css-extract-plugin
export var orderSummary = "_r6-0";
export var showMoreLessButton = "_r6-1";